import { NOT_SET } from './not-set.js';
export function orNotSet(value) {
    const trimmed = value?.trim();
    return trimmed ? trimmed : NOT_SET;
}
//# sourceMappingURL=or-not-set.js.map